export const environment = {
    production: false,
    api: 'https://api.sayobot.cn',
};
